<script lang="ts" setup>
import { useFormField } from '@fondof-ui/components/form/useFormField'
import { Slot } from 'radix-vue'

const {
  error,
  warning,
  formItemId,
  formDescriptionId,
  formMessageId,
  formWarningId,
} = useFormField()

const ariaDescribedBy = Object.entries({
  [formDescriptionId]: !error && !warning,
  [formMessageId]: !!error,
  [formWarningId]: !!warning,
})
  .filter(([_, value]) => value)
  .map(([key]) => key)
  .join(' ')
</script>

<template>
  <Slot
    :id="formItemId"
    :aria-describedby="ariaDescribedBy"
    :aria-invalid="!!error"
  >
    <slot />
  </Slot>
</template>
